// Desktop Hero Text - Pure White
document.addEventListener('DOMContentLoaded', function() {
  // Only run on desktop
  if (window.innerWidth >= 750) {
    // Function to set hero text to white
    function setHeroTextToWhite() {
      // Target all possible text elements in hero sections
      const heroTextElements = document.querySelectorAll(`
        .banner__heading, 
        .banner__text, 
        .hero-slide__heading, 
        .hero-slide__text,
        .banner__box h1, 
        .banner__box h2, 
        .banner__box h3, 
        .banner__box p, 
        .banner__box span,
        .hero-slide__content h1, 
        .hero-slide__content h2, 
        .hero-slide__content h3, 
        .hero-slide__content p, 
        .hero-slide__content span
      `);
      
      // Set each element to white
      heroTextElements.forEach(element => {
        element.style.color = '#FFFFFF';
        element.style.textShadow = '0px 2px 4px rgba(0, 0, 0, 0.7)';
      });
    }
    
    // Run immediately
    setHeroTextToWhite();
    
    // Run again after a short delay to catch any dynamically loaded content
    setTimeout(setHeroTextToWhite, 500);
    
    // Run again after the page is fully loaded
    window.addEventListener('load', setHeroTextToWhite);
  }
});
